import { Button, Modal } from "antd";

const DeleteModal = ({
  open,
  handleCancel,
  handleDelete,
  title,
  description,
  confirmButtonText = "Confirm",
  modalType = "delete",
  ...rest
}) => {
  return (
    <>
      <Modal
        title={
          <div className="d-flex flex-column align-items-center text-center">
            <div className="d-flex justify-content-center w-100 mb-2">
              <img src="/assets/delete-icon.png" alt="delete-logo" />
            </div>
            <div className="mt-4 px-3 text-start">
              <h3 className="delete-css">{title}</h3>
              <p className="mt-3 delete-para-css">{description}</p>
            </div>
          </div>
        }
        open={open}
        onCancel={handleCancel}
        footer={
          <div
            style={{
              display: "flex",
              gap: "8px",
              padding: "20px",
            }}
          >
            <Button
              key="cancel"
              onClick={handleCancel}
              style={{
                flex: 1,
                background: "#FFFFFF",
                color: "#6B6B6B",
                border: "1px solid #EDEDED",
                paddingTop: "24px",
                paddingBottom: "24px",
                fontSize: "18px",
                borderRadius: "0px",
              }}
            >
              Cancel
            </Button>
            <Button
              key="confirm"
              style={{
                flex: 1,
                background: modalType === "delete" ? "#F44336" : "#052659",
                color: "#FFFFFF",
                border: "none",
                paddingTop: "24px",
                paddingBottom: "24px",
                fontSize: "18px",
                borderRadius: "0px",
              }}
              onClick={handleDelete}
            >
              {confirmButtonText}
            </Button>
          </div>
        }
        {...rest}
      ></Modal>
    </>
  );
};

export default DeleteModal;
